module.exports = __webpack_public_path__ + "img/2.fd6c8ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.jpg
// module id = 206
// module chunks = 1